import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onBeforeMount, ref, provide } from "vue";
import { useStore } from "vuex";
import { setLocale } from "@/utils/i18n";
import Home from "@/views/pages/Home.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userInfo = ref<any>(null);
onBeforeMount(() => {
  const store = useStore();
  const load = async () => {
    await store.dispatch("fetchUser"); // ユーザー情報を取得
    userInfo.value = store.getters.getUser;
    let lang = "ja"; // 言語切り替えが必要ならここでやる
    setLocale(lang);
  };
  load();

  const refreshUserInfo = async () => {
    await load();
    return userInfo.value;
  };
  provide("refreshUserInfo", refreshUserInfo);
});

return (_ctx: any,_cache: any) => {
  return (userInfo.value)
    ? (_openBlock(), _createBlock(Home, { key: 0 }))
    : _createCommentVNode("", true)
}
}

})